import { computed } from 'vue'
import { useTransactionsStore } from '@/store/modules/transactions'
import { useReplenishmentsStore } from '@/store/modules/replenishments'
import { TransactionType } from '@/api/types'
import { IReplenishment } from '@/interfaces/replenishments'
import { ITransaction } from '@/interfaces/transactions'

export const itemsIncome = computed(() => {
  const replenishmentsStore = useReplenishmentsStore()
  const transactionsStore = useTransactionsStore()

  const result: Array<ITransaction> = []
  const transactions =
    transactionsStore.currentItems[TransactionType.Added] || []
  transactions.forEach((element: ITransaction, index: number) => {
    result.push(element)
  })
  const replenishments = replenishmentsStore.currentItems.filter(
    (p: IReplenishment) => p.attributes.status === 'rejected'
  )
  replenishments.forEach((element: IReplenishment, index: number) => {
    result.push({
      id: element.id,
      attributes: {
        comment: element.attributes.message,
        commission: 0,
        vat: 0,
        total_amount: 0,
        amount: element.attributes.amount,
        created_at: element.attributes.created_at || '',
        created_int: element.attributes.created_int,
        type_id: 7
      }
    })
  })
  return result.sort((a, b) => {
    return b.attributes.created_int - a.attributes.created_int
  })
})

export const totalIncome = computed(() => {
  const transactionsStore = useTransactionsStore()

  return transactionsStore.total[TransactionType.Added] || 0
})
